"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CloseIcon = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("../../assets/styles/config");
exports.CloseIcon = styled_components_1.default.i `
  color: ${config_1.colors.thundercloud};
  font-size: 14px;
  margin: 5px;
  position: relative;
`;
